import { useCallback, useEffect, useState } from 'react';
import { ConfirmDialog } from '../training/ConfirmDialog';
import { registerConfirmHost, type ConfirmRequest } from '../../lib/dialogs';

// Mostra as confirmações pedidas por confirmAction(), uma de cada vez.
export function ConfirmHost() {
  const [queue, setQueue] = useState<ConfirmRequest[]>([]);

  useEffect(() => registerConfirmHost(req => setQueue(q => [...q, req])), []);

  const current = queue[0];
  const answer = useCallback((ok: boolean) => {
    current?.resolve(ok);
    setQueue(q => q.slice(1));
  }, [current]);
  const onConfirm = useCallback(() => answer(true), [answer]);
  const onCancel = useCallback(() => answer(false), [answer]);

  if (!current) return null;
  return (
    <ConfirmDialog
      open
      title={current.title}
      description={current.message}
      confirmLabel={current.confirmLabel}
      cancelLabel={current.cancelLabel}
      danger={current.danger}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
